var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#262261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6501 15.2629L27.4635 15.3642C29.3408 15.598 30.75 17.1936 30.75 19.0855V29.5749C30.75 31.4118 29.3817 32.961 27.5589 33.188C24.5313 33.5651 21.4687 33.5651 18.4411 33.188C16.6183 32.961 15.25 31.4118 15.25 29.5749V19.0854C15.25 17.1936 16.6592 15.598 18.5365 15.3642L19.3499 15.2629C19.6721 14.1021 20.7365 13.25 22 13.25H24C25.2635 13.25 26.3279 14.1021 26.6501 15.2629ZM19.25 16.7869L18.7219 16.8527C17.5955 16.993 16.75 17.9503 16.75 19.0854V29.5749C16.75 30.655 17.5546 31.566 18.6265 31.6995C21.5309 32.0612 24.4691 32.0612 27.3735 31.6995C28.4454 31.566 29.25 30.655 29.25 29.5749V19.0855C29.25 17.9503 28.4045 16.993 27.2781 16.8527L26.75 16.7869V18C26.75 18.4142 26.4142 18.75 26 18.75H20C19.5858 18.75 19.25 18.4142 19.25 18V16.7869ZM20.75 16C20.75 15.3096 21.3096 14.75 22 14.75H24C24.6904 14.75 25.25 15.3096 25.25 16V17.25H20.75V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 22.75C26.75 22.3358 26.4142 22 26 22H20C19.5858 22 19.25 22.3358 19.25 22.75C19.25 23.1642 19.5858 23.5 20 23.5H26C26.4142 23.5 26.75 23.1642 26.75 22.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 25.75C25.75 25.3358 25.4142 25 25 25H20C19.5858 25 19.25 25.3358 19.25 25.75C19.25 26.1642 19.5858 26.5 20 26.5H25C25.4142 26.5 25.75 26.1642 25.75 25.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsBlue);
export default __webpack_public_path__ + "static/media/forms-blue.ffc683f191c8504f759828aafcc3986b.svg";
export { ForwardRef as ReactComponent };